module.exports = __webpack_public_path__ + "img/Affin-buys-TRX.1638ab62.jpg";